// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92342cce","453":"7e869502","455":"4ff1fbe2","977":"713c9b7a"}[chunkId] + ".chunk.js";
};